module.exports = __webpack_public_path__ + "img/40_00_031_376.1102e608.jpg";